// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__eVjg8","main":"Footer_main__WFOJ-","bottom":"Footer_bottom__-B7QM","info":"Footer_info__nk0Cd","socials":"Footer_socials__1SP69"};